import { ErrorWrapper, ResponseWrapper } from './util'
import { RoomBaseApiService } from '@/core/service/room.baseapi.service'

class RoomChatService extends RoomBaseApiService {
  constructor(props) {
    super(props)
  }

  async sendChatMessage(data = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        `/api/v3/room/${this.getRoomId()}/chat/textReact`,
        {
          ...data
        }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async sendChatEmoticon(data = {}) {
    try {
      const response = await this.request({ auth: true }).post(
        `/api/v3/room/${this.getRoomId()}/chat/emoticon`,
        {
          ...data
        }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async startShareChat(params) {
    try {
      const response = await this.request({ auth: true }).get(
          `/api/v3/room/${this.getRoomId()}/chat/${params.chatUUID}/share/start`
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async endShareChat(params) {
    try {
      const response = await this.request({ auth: true }).get(
          `/api/v3/room/${this.getRoomId()}/chat/${params.chatUUID}/share/end`
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}

export const roomChatService = new RoomChatService()
